// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"aTnzKl","text":"JpRBKF","titleContainer":"_1Ugq7F"};